import React from 'react';
import ButtonMui, { ButtonProps } from '@material-ui/core/Button';

export const Button: React.FC<ButtonProps> = ({ children, ...rest }) => {
	return <ButtonMui {...rest}>{children}</ButtonMui>;
};
